<template>
    <div class="vap-page">
        <Loading
         :active.sync="isLoading"
         :is-full-page="false"
         :color="loaderColor"
         loader="dots"
         :background-color="loaderBackgroundColor"
        />
        <div class="vap-page-header">
            <h1>API Accounts</h1>
                <div class="btns-container">
                    <VasionButton
                     id="btnNewApiAccount"
                     class="last-btn"
                     classProp="primary"
                     @vasionButtonClicked="newApiAccount"
                    >
                        Add Account
                    </VasionButton>
                </div>
        </div>
        <div class="vap-page-content">
            <div class="main-table-container vasion-html-table-default">
                <VasionTable
                 :headerColumns="ColumnValues"
                 :hideColumns="hiddenColumns"
                 :tableRows="tableData.Rows.Values"
                 :filterByColumnDefault="1"
                 :ellipsisButtonConfig="ellipsisButtonConfig"
                 @ellipsis-button-clicked="ellipsisButtonClicked"
                 @vasion-selection="rowClickHandler"
                />
            </div>
        </div>
        <md-dialog id="confirmDelete" :md-active.sync="showDeleteDialog" :md-click-outside-to-close="false">
            <VasionConfirmationDialog :message="deletePromptMessage" @noButtonClick="toggleDeleteDialog()" @yesButtonClick="deleteApiAccountAndToggle()" />
        </md-dialog>
        <VasionSnackbar
         id="snackbar-api-account-list"
         ref="apiAccountListSnackbar"
         :showSnackbarBool.sync="snackbar.snackbar"
         :snackbarImage="snackbar.image"
         :snackbarSubTitle="snackbar.subTitle"
         :snackbarTitle="snackbar.title"
        />
        <VasionGeneralModal
            :modalTitle="'Edit API Account'"
            :modalType="'slot'"
            :sync="showAPIAuthenticationModal"
            :confirmButtonText="apiAccountSave"
            :rejectButtonText="'Cancel'"
            :showCustomButton="false"
            @noButtonClick="showAPIAuthenticationModal = false"
            @confirmButtonClick="confirmButtonClicked()"
        >
            <APIAuthentication :accountConfig="accountConfig" @updateAccountConfig="onUpdateAccountConfig" @showSnackbar="showAuthenticationSnackbar"/>
        </VasionGeneralModal>
        <VasionSnackbar
                id="snackbar-api-authentication"
                ref="apiAuthenticationSnackbar"
                :showSnackbarBool.sync="snackbarAuthentication.snackbar"
                :snackbarImage="snackbarAuthentication.image"
                :snackbarSubTitle="snackbarAuthentication.subTitle"
                :snackbarTitle="snackbarAuthentication.title"
            />
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import APIAuthentication from '../../../components/admin/authentication/APIAuthentication.vue';

// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
    name: 'ApiAccounts',
    components: {
        APIAuthentication,
        Loading,
    },
    data: function () {
        return {
            ColumnValues: [
                'AccountID',
                'Name',
                'Type',
                '_VasionEllipsisButton_',
            ],
            deleteApiAccountID: 0,
            deleteApiAccountName: '',
            deletePromptMessage: 'Are you sure you want to delete this api account?',
            hiddenColumns: [
                'AccountID',
            ],
            isLoading: false,
            loaderColor: loaderColor,
            loaderBackgroundColor: loaderBackgroundColor,       
            showAPIAuthenticationModal: false,    
            showDeleteDialog: false,
            snackbar: {
                image: '',
                snackbar: false,
                subTitle: '',
                title: '',
            },
            snackbarAuthentication: {
                image: '',
                snackbar: false,
                subTitle: '',
                title: '',
            },
            accountConfig: {},
            tableData: {
                Rows: {
                    Values: [],
                },
            },
            updatedAccountConfig: {},
        };
    },
    computed: {
        apiAccountSave() { return this.$store.state.admin.apiAccountSave },
        ellipsisButtonConfig() { return this.$store.state.security.ellipsisButtonConfig },
    },
    created() {
            this.refreshTable()
            this.$store.dispatch('security/setEllipsisButtonConfig', 'api-accounts')
    },
    watch: {
        showAPIAuthenticationModal: function (newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$refs.apiAccountListSnackbar.closeSnackbar()
                })
            }
        },
    },
    methods: {
      async confirmButtonClicked() {
        if (!this.updatedAccountConfig.name || !this.updatedAccountConfig.type) {
          this.showSnackbar('Error', 'Name and type are required.', false)
          return
        }
        if (this.updatedAccountConfig.type == 1 && !(this.updatedAccountConfig.username || this.updatedAccountConfig.password)) {
          this.showSnackbar('Error', 'Username or Password is required for basic type.', false)
          return
        }
        if (this.updatedAccountConfig.type == 2 && !(this.updatedAccountConfig.token && this.updatedAccountConfig.fieldLocation)) {
          this.showSnackbar('Error', 'Token and Token Location is required for API Token type.', false)
          return
        }
        else if (this.updatedAccountConfig.type == 3 && !(this.updatedAccountConfig.authUrl && this.updatedAccountConfig.clientId && this.updatedAccountConfig.clientSecret)) {
          this.showSnackbar('Error', 'Auth URL, Client ID, and Client Secret are required for OAuth type.', false)
          return
        }
        if (this.updatedAccountConfig.type == 3) {
            this.updatedAccountConfig.state = this.generateRandomString()
        }

        const response = await this.$store.dispatch('admin/saveAPIAuthentication', this.updatedAccountConfig)
        if (response && response.Value === 'False') {
          this.showSnackbar('Error', response.ResultMessage || 'An unexpected error occurred. Please try again.', false)
          return
        }

        if (this.updatedAccountConfig.type == 3) {
            let endpoint = this.updatedAccountConfig.authUrl
            const redirectURL = `${endpoint}?client_id=${this.updatedAccountConfig.clientId}&redirect_uri=${this.updatedAccountConfig.redirectURI}&scope=${this.updatedAccountConfig.scopes}&response_type=code&state=${this.updatedAccountConfig.state}`
            window.location.replace(encodeURI(redirectURL))
        }

        this.showSnackbar('Success', 'API Authentication saved successfully.', true)
        this.showAPIAuthenticationModal = false
        this.refreshTable()
      },
        async deleteApiAccountAndToggle() {
            if (this.deleteApiAccountID <= 0) {
                this.showSnackbar('Error', 'Invalid lookup ID.', false)
                return
            }
            try{
                const wasDeleted = await this.$store.dispatch('admin/deleteApiAuthentication', this.deleteApiAccountID)
                if (wasDeleted && wasDeleted.Value === 'False') {
                    const message = wasDeleted.ResultMessage || 'An unexpected error occurred. Please try again.'
                    this.showSnackbar('Error', message, false)
                    return
                }
                this.refreshTable()
                this.showSnackbar('Success', 'Lookup deleted successfully.', true)
            } catch (error) {
                this.showSnackbar('Error', 'Error deleting api account.', false)
            } finally{
                this.deleteApiAccountID = 0
                this.deleteApiAccountName = ''
                this.toggleDeleteDialog()
            }
        },
        deleteApiAccountClick(apiAccountID, apiAccountName) {
            this.deleteApiAccountID = apiAccountID
            this.deleteApiAccountName = apiAccountName

            this.toggleDeleteDialog()
        },
        async editApiAccount(apiAccountID) {
            if(apiAccountID > 0){
                this.accountConfig = await this.$store.dispatch('admin/getApiAuthentication', apiAccountID)
            }
            this.showAPIAuthenticationModal = true
        },
        ellipsisButtonClicked(payload) {
            if (payload?.item?.Values[0]) {
                const [id, name] = payload.item.Values
                switch (payload.buttonId) {
                    case 'edit-api-account-button':
                        this.editApiAccount(id)
                        break;
                    case 'delete-api-account-button':
                        this.deletePromptMessage = `Are you sure you want to delete "${name}"?`
                        this.deleteApiAccountClick(id, name)
                        this.showDeleteDialog = true
                        break;
                    default:
                        break;
                }
            }
        },
        generateRandomString(length = 30) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
            let result = '';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        getApiAccountType(typeValue) {
            switch(typeValue){
                case 1:
                    return 'Basic'
                case 2:
                    return 'Token'
                case 3:
                    return 'OAuth2'
                default:
                    return ' '
            }
        },
        async refreshTable() {
            this.isLoading = true

            const response = await this.$store.dispatch(
                'admin/getAllApiAuthentications'
            )           

            this.tableData = {
                Rows: {
                    Values: [],
                },
            }

            if(response && response?.List) {
                this.tableData.Rows.Values = response.List.map(apiAuthentication => {
                    const dataRow = [
                        apiAuthentication.id,
                        apiAuthentication.name,
                        this.getApiAccountType(apiAuthentication.type),
                        'VasionEllipsisIcon',
                    ]

                    const retElement = {
                         Values: dataRow,
                        ValueType: 'String',
                    }

                    return retElement
                })
            }
            this.isLoading = false

            let redirectURI = window.location.href
            const routeName = 'integration/apiaccounts'
            const indexOf = redirectURI.indexOf(routeName)
            if (indexOf >= 0) {
                redirectURI = redirectURI.substring(0, indexOf + routeName.length)
            }

            if (this.$route.query.error) {
              this.showSnackbar('Authentication Failure', 'You were unable to authenticate', false)
              return
            }

            if (response?.List.length > 0) {
                const state = this.$route.query.state
                const authCode = this.$route.query.code

                if (!state) {
                    return
                }
                let config = response.List.find(config => {
                    return state === config.state
                })
                const authCodePayload = {
                    authId: config.id,
                    code: authCode,
                }
                const setCodeResult = await this.$store.dispatch('admin/setApiAuthenticationCode', authCodePayload)
                if (setCodeResult && setCodeResult.Value === 'True') {
                    this.showSnackbar('Authentication Success!', 'You have successfully authenticated!', true)
                } else {
                    this.showSnackbar('Authentication Failure', 'You were unable to authenticate', false)
                }
            }
        },
        rowClickHandler(row) {
            this.editApiAccount(row.Values[0])
        },
        newApiAccount() {
            this.accountConfig = {}
            this.editApiAccount(0)
        },
        onUpdateAccountConfig(config) {
            this.updatedAccountConfig = config
        },
        showAuthenticationSnackbar(title, subTitle, isSuccess) {
            this.snackbarAuthentication = {
                image: isSuccess,
                snackbar: true,
                subTitle: subTitle,
                title: title,
            }
        },
        showSnackbar(title, subTitle, isSuccess) {
            this.snackbar = {
                image: isSuccess,
                snackbar: true,
                subTitle: subTitle,
                title: title,
            }
        },
        toggleDeleteDialog() { this.showDeleteDialog = !this.showDeleteDialog },
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.scss';


</style>